import React from 'react';

import { Trash2 as Trash } from 'react-feather';

export const DeleteIcon = ({ size = 16 }) => <Trash size={size} />;
